// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"1a23492b","139":"3371b90f","200":"a6f4844d","380":"3c960e3d","417":"9874a553","453":"9098e6aa","560":"2b1e3e33","761":"9a1b3a63"}[chunkId] + ".chunk.js";
};